<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش اعضایی که وام های خود را تسویه نموده اند" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding: 0 40px 40px">
					<v-row>
						<v-col cols="11">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="1">
							<export-excel :items="items" :headers="headers" :fileName="'لیست اعضا تسویه شده'">
							</export-excel>
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="items" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											{{ row.item.firstName }}
										</td>
										<td>
											{{ row.item.lastName }}
										</td>
										<td>
											{{ row.item.mobile }}
										</td>
										<td class="text-center">
											{{ row.item.loanCount }}
										</td>
										<td class="text-center">
											{{ row.item.loanSum.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.checkoutDate }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'CheckoutThisMonth',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'نام',
						align: 'start',
						sortable: true,
						value: 'firstName',
					},
					{
						text: 'نام خانوادگی',
						align: 'start',
						sortable: true,
						value: 'lastName',
					},
					{
						text: 'موبایل',
						align: 'start',
						sortable: true,
						value: 'mobile',
					},
					{
						text: 'تعداد وام',
						align: 'center',
						sortable: true,
						value: 'loanCount',
					},
					{
						text: 'مجموع وام ها',
						align: 'center',
						sortable: true,
						value: 'loanSum',
					},
					{
						text: 'تاریخ آخرین تسویه',
						align: 'center',
						sortable: true,
						value: 'checkoutDate',
					},
				],
				items: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api
					.get('admin/report/CheckoutedMembers', null)
					.then((response) => {
						this.items = response
					})
					.catch((err) => {
						toast.error(err.message)
					})
					.finally((x) => {
						this.loading = false
					})
			},
		},
	}
</script>
<style>
</style>
